__webpack_require__.p = "/wp-content/themes/sw_theme/themes-starter-bootstrap-main/assets/app/build/";